









































import { Component, Prop } from "vue-property-decorator";
import { ThgBaseChartItemViewmodelGen } from "@/services/thg/v1/data-contracts";
import CsvExportMixin from "@/mixins/CsvExportMixin.vue";
import * as XLSX from "xlsx";

@Component({
  components: {}
})
export default class AnalyticsDataTableDialog extends CsvExportMixin {
  @Prop({ default: () => [] })
  data!: ThgBaseChartItemViewmodelGen[];

  search = "";
  isLoading = false;

  get headers() {
    return [
      { text: this.$t("components.analytics.AnalyticsDataTableDialog.variable"), value: "name" },
      { text: this.$t("components.analytics.AnalyticsDataTableDialog.value"), value: "value" }
    ];
  }

  dialog = false;

  async exportData() {
    this.isLoading = true;

    const exportData = (this.data || []).map(item => ({
      [this.$t("components.analytics.AnalyticsDataTableDialog.name").toString()]: item.name,
      [this.$t("components.analytics.AnalyticsDataTableDialog.value").toString()]: item.value
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      this.$t("components.analytics.AnalyticsDataTableDialog.data").toString()
    );

    const exportTitle = `analytics_export_${new Date().toISOString().split("T")[0]}.xlsx`;
    XLSX.writeFile(workbook, exportTitle, {
      compression: true
    });

    this.dialog = false;
    this.isLoading = false;
  }

  close() {
    this.dialog = false;
  }
}
